<template>
  <div class="create-transaction">
    <div class="container">
      <div class="notification has-text-left">
        <!-- Workflow -->
        <div class="field">
          <p class="label">Workflow</p>
          <div class="control has-icons-left">
            <div class="select is-fullwidth">
              <select @change="selectWorkflow($event)">
                <option disabled selected value>
                  -- Select Workflow Type --
                </option>
                <option v-for="w in workflows" :value="w" :key="w">
                  {{ w }}
                </option>
              </select>
              <span class="icon is-small is-left">
                <i class="fas fa-briefcase"></i>
              </span>
            </div>
          </div>
        </div>

        <!-- Business -->
        <div class="field">
          <p class="label">Business</p>
          <div class="control has-icons-left">
            <div class="select is-fullwidth">
              <select @change="selectBusiness($event)">
                <option disabled selected value>-- Select Business --</option>
                <option v-for="b in businesses" :value="b.key" :key="b.key">
                  {{ b.key }}
                </option>
              </select>
              <span class="icon is-small is-left">
                <i class="fas fa-store-alt"></i>
              </span>
            </div>
          </div>
        </div>

        <!-- Driver -->
        <div class="field">
          <p class="label">Driver</p>
          <div class="control has-icons-left">
            <div class="select is-fullwidth is-success">
              <select @change="selectDriver($event)">
                <option disabled selected value>-- Select Driver --</option>
                <option value>** Any Driver **</option>
                <option v-for="d in drivers" :value="d.value" :key="d.key">
                  {{ d.key }}
                </option>
              </select>
              <span class="icon is-small is-left">
                <i class="fas fa-shuttle-van"></i>
              </span>
            </div>
          </div>
        </div>

        <div class="field">
          <p class="label">
            Passenger
            <span
              class="has-text-danger"
              style="font-size: 0.8em"
              v-if="isPhoneNumberPassenger"
              >(By Phone Number)</span
            >
          </p>
          <div class="control has-icons-left">
            <!-- :value="passengerName" -->
            <input
              class="input is-success"
              type="text"
              :value="passengerName"
              @focus="clearPassenger"
              placeholder="Name or phone number"
              @keyup="lookupPassengers($event)"
            />
            <!-- @blur="passengers=[]" -->
            <span class="icon is-small is-left">
              <i class="fas fa-user"></i>
            </span>
          </div>
          <div class="list" v-if="passengers.length > 0">
            <span
              v-for="p in passengers"
              class="list-item"
              :key="p.key"
              @click="selectPassenger(p)"
              >{{ p.key }}</span
            >
          </div>
        </div>

        <div class="field" v-if="pickupName || dropoffName">
          <p class="label">Locations</p>
        </div>

        <div class="has-text-left">
          <div
            v-if="pickupName"
            class="field tags has-addons single-line"
            style="margin: 0 0"
          >
            <span
              class="tag is-link is-medium is-rounded"
              @click="pickup = null"
            >
              <i class="fa fa-times-circle" />&nbsp;
              <span>Pickup</span>
            </span>
            <span class="tag is-white is-medium has-text-link">
              <a :href="pickupMap" target="_blank">{{ pickupName }}</a>
              <i class="fa fa-map has-text-link" style="margin-left: 4px" />
              <!-- &nbsp;<button class="delete" @click="pickup=null" />&nbsp; -->
            </span>
          </div>

          <div v-if="dropoffName" class="field tags has-addons single-line">
            <span
              class="tag is-primary is-medium is-rounded"
              @click="dropoff = null"
            >
              <!-- <i class="fa fa-map-marker-alt" />&nbsp; -->
              <i class="fa fa-times-circle" />&nbsp;
              <span>Dropoff</span>
            </span>
            <span class="tag is-white is-medium has-text-link">
              <a :href="dropoffMap" target="_blank">{{ dropoffName }}</a>
              <i class="fa fa-map has-text-primary" style="margin-left: 4px" />
              <!-- &nbsp;<button class="delete" @click="dropoff=null" />&nbsp; -->
            </span>
          </div>
        </div>

        <div class="field" v-show="!pickupName || !dropoffName">
          <p class="label" v-if="!pickupName" @click="useCoords">Pickup</p>
          <p class="label" v-if="pickupName && !dropoffName" @click="useCoords">
            Dropoff
          </p>
          <div class="control has-icons-left">
            <input
              id="transaction-form-google"
              class="input is-link"
              type="text"
              ref="autocomplete"
              onfocus="value = ''"
              placeholder="Location"
            />
            <span class="icon is-small is-left">
              <i class="fas fa-map-marker-alt"></i>
            </span>
          </div>
        </div>

        <!-- Based on pickup/dropoff should pre-fill cash and tukpay fields -->
        <div class="columns is-mobile">
          <div class="column" style="max-width: 50vw">
            <div class="field">
              <p class="label">Date</p>
              <div class="control has-icons-left">
                <span class="icon is-small is-left">
                  <i class="fa fa-calendar-alt"></i>
                </span>
                <b-field type="is-warning">
                  <b-datepicker
                    v-model="date"
                    placeholder="Today"
                    :min-date="today"
                  ></b-datepicker>
                </b-field>
              </div>
            </div>
          </div>
          <div class="column" style="max-width: 50vw">
            <div class="field">
              <p class="label">Time</p>
              <div class="control has-icons-left">
                <span class="icon is-small is-left">
                  <i class="fas fa-clock" />
                </span>
                <b-field type="is-warning">
                  <b-timepicker
                    v-model="time"
                    placeholder="Now"
                    hour-format="24"
                  ></b-timepicker>
                </b-field>
              </div>
            </div>
          </div>
        </div>

        <!-- Based on pickup/dropoff should pre-fill cash and tukpay fields -->
        <div class="columns is-mobile">
          <div class="column">
            <div class="field">
              <p class="label">Cash</p>
              <div class="control has-icons-left">
                <input
                  class="input is-danger"
                  v-model="cash"
                  type="number"
                  placeholder="฿30"
                />
                <span class="icon is-small is-left">
                  <i class="fab fa-btc"></i>
                </span>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <p class="label">TukPay</p>
              <div class="control has-icons-left">
                <input
                  class="input is-danger"
                  v-model="tukpay"
                  type="number"
                  placeholder="฿30"
                />
                <span class="icon is-small is-left">
                  <i class="fab fa-btc"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div style="height: 8px" />
        <div class="field">
          <div class="control">
            <button
              class="button is-success is-fullwidth"
              @click="createTransaction"
            >
              Create Transaction
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $Scriptjs from "scriptjs";
// import EventBus from "../eventBus";
// import CurrentLocationModal from "@/components/CurrentLocationModal.vue";

export default {
  name: "CreateTransactionForm",
  components: {
    // CurrentLocationModal
  },
  data() {
    return {
      workflows: [
        "Sii Lor",
        "Private Tuk Tuk",
        "Songthaew",
        "Public Tuk Tuk",
        "Taxi",
        "Fleet",
        "Motocy",
      ],
      businesses: [],
      drivers: [],
      passengers: [],
      passengerName: "",
      selectedPassenger: null,
      selectedDriver: "",
      pickup: null,
      dropoff: null,
      workflowType: "",
      workflowID: "",
      businessID: "",
      passengerID: "",
      driverID: "",
      pickupURL: "",
      dropoffURL: "",
      cash: null,
      tukpay: null,
      time: null,
      date: null,
    };
  },
  computed: {
    pickupName() {
      if (!this.pickup) return false;
      return this.pickup.name;
    },
    dropoffName() {
      if (!this.dropoff) return false;
      return this.dropoff.name;
    },
    pickupMap() {
      return this.pickupURL;
    },
    dropoffMap() {
      return this.dropoffURL;
    },
    today() {
      var now = new Date();
      return now;
      // var dt = new Date(now - 1000 * 60 * 60 * 24); // subtract a day
    },
    isPhoneNumberPassenger() {
      if (this.passengerID === "") return false;
      if (this.passengerID !== this.passengerName) return false;
      return true;
    },
  },
  mounted() {
    var googleURL = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBYOwhqakcxLQQLpljhkug2WsNSA02cqss&libraries=places`;
    $Scriptjs(googleURL, () => this.initGoogle());
  },
  activated() {},
  methods: {
    clearPassenger() {
      this.passengerName = "";
      this.passengerID = "";
    },
    selectPassenger(p) {
      this.passengerID = p.value;
      console.log("selectPassenger", p);
      this.passengerName = p.key;
      this.passengers = [];
    },
    selectWorkflow(e) {
      // need to clear any previously selected business or driver
      this.businessID = ""; // clear
      this.businesses = []; // clear
      this.drivers = [];
      var workflowType = e.target.value;
      this.workflowType = workflowType;
      console.log("selected workflow", e.target.value);
      // now fetch relevant businesses
      this.$store
        .dispatch("autocompleteBusinessWorkflows", workflowType)
        .then((res) => {
          if (res.data) this.businesses = res.data;
          else this.businesses = [];
        })
        .catch((err) => console.error("autocompleteBusinesses", err));
    },
    selectBusiness(e) {
      var key = e.target.value;
      var b = this.businesses.find((b) => b.key === key);
      this.businessID = b.business_id;
      this.workflowID = b.workflow_id;
      console.log("selected business", key, b);
      // now fetch business-workflow drivers
      this.$store
        .dispatch("autocompleteDriverWorkflows", b.workflow_id)
        .then((res) => {
          if (res.data) this.drivers = res.data;
          else this.drivers = [];
        })
        .catch((err) => console.error("autocompleteDrivers", err));
    },
    selectDriver(e) {
      this.driverID = e.target.value;
      console.log("selected driver", this.driverID, e);
    },
    lookupPassengers(e) {
      var text = e.target.value;
      this.passengerName = text;
      console.log("lookupPassengers", text);
      if (text.length < 3) {
        this.passengers = [];
      } else {
        if (text[0] === "+") {
          this.passengerID = text; // phone number can act as temporary passenger ID
          console.log("passengerID", text);
          return; // entering phone number don't look up users
        }
        this.$store
          .dispatch("autocompleteUsers", text)
          .then((res) => {
            if (res.data) this.passengers = res.data;
            else this.passengers = [];
          })
          .catch((err) => console.error("userAutocomplete", err));
      }
    },
    useCoords() {
      this.$swal({
        title: `Paste Coordinates`,
        html: `For super users 🤫`,
        input: "text",
        inputPlaceholder: "18.8983027,99.0111249",
        confirmButtonText: this.$t("submit"),
        cancelButtonText: this.$t("cancel"), //"Oops, not a super user",
        showCancelButton: true,
        cancelButtonColor: this.bulmaColor("danger"),
        confirmButtonColor: this.bulmaColor("info"),
        inputValidator: (txt) => {
          if (!txt || txt.length < 6 || txt.indexOf(",") === -1)
            return "Enter latitude,longitude";
        },
      }).then((val) => {
        if (val.value) {
          var latString = val.value.split(",")[0];
          var lonString = val.value.split(",")[1];
          var lat = parseFloat(latString);
          var lon = parseFloat(lonString);
          var msg = `Incorrect format [ ${val.value} ] please enter latitude,longitude with no spaces.`;
          if (!lat || !lon) return this.errorToast(msg);
          this.infoToast(lat + ", " + lon);
          // this.updateMarkerLocation({ lat: lat, lon: lon });
          var stop = {
            id: "special_stop",
            name: "Map Pin",
            lat: lat,
            lon: lon,
          };
          var url = `http://www.google.com/maps/place/${lat},${lon}`;
          if (!this.pickup) {
            this.pickup = stop;
            this.pickupURL = url;
          } else {
            this.dropoff = stop;
            this.dropoffURL = url;
          }
        }
      });
    },
    createStop(place) {
      return {
        id: "special_stop",
        name: place.name,
        lat: place.geometry.location.lat(),
        lon: place.geometry.location.lng(),
      };
    },
    initGoogle() {
      this.autocomplete = new google.maps.places.Autocomplete(
        this.$refs.autocomplete,
        {
          types: [],
          // componentRestrictions: { country: "th" }
        }
      ); // uses all, options are ["address", "establishment", "geocode"]
      this.geolocate(); // Bias autocomplete to the user geolocation,

      this.autocomplete.addListener("place_changed", () => {
        var place = this.autocomplete.getPlace();
        this.console(`The user picked ${place.name}`, place);
        this.addressName = place.name;
        this.fullAddress = place.formatted_address;
        this.url = place.url;
        this.place = place;
        var stop = this.createStop(place);
        if (!this.pickup) {
          this.pickup = stop;
          this.pickupURL = place.url;
        } else {
          this.dropoff = stop;
          this.dropoffURL = place.url;
        }
        document.getElementById("transaction-form-google").focus();
      });
    },
    // Bias autocomplete to the user geolocation,
    geolocate() {
      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition((position) => {
        var coords = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        var circle = new google.maps.Circle({
          center: coords,
          radius: position.coords.accuracy,
        });
        this.autocomplete.setBounds(circle.getBounds());
      });
    },
    getFare() {
      if (!this.tukpay) this.tukpay = 0;
      if (!this.cash) this.cash = 0;
      var price = parseInt(this.tukpay) + parseInt(this.cash);
      var discount = parseInt(this.tukpay);
      return {
        version: "v1",
        price: price,
        discount: discount,
        cash: parseInt(this.cash),
        tukpay: parseInt(this.tukpay),
      };
    },
    formCompleted() {
      if (
        // this.driverID === "" ||
        this.passengerID === "" ||
        !this.pickup // || !this.dropoff
      ) {
        this.warningAlert("Please enter passenger and pickup details");
        return false;
      }
      if (this.date && !this.time) {
        this.warningAlert("You must set a time");
        return false;
      }
      return true;
    },
    parseScheduledTime() {
      if (!this.date) {
        return this.time.toISOString(); // time will always be set currently
      }
      // actually could let user not enter and default to NOW, not scheduled
      var dt = this.date;
      dt.setHours(this.time.getHours());
      dt.setMinutes(this.time.getMinutes());
      if (dt < new Date()) {
        alert("Scheduled time cannot be in the past!!");
        return null; // can't be in the past
      }
      return dt.toISOString();
    },
    createTransaction() {
      var obj = {
        // type: "scheduled",
        pickup_stop: this.pickup,
        dropoff_stop: this.dropoff,
        fare: this.getFare(),
      };
      if (this.time) {
        if (!this.parseScheduledTime()) return; // means error parsing time, don't continue
        obj.type = "scheduled";
        obj.scheduled_time = this.parseScheduledTime();
      }
      if (!this.formCompleted()) return;
      var loader = this.loadingDots();
      this.$store
        .dispatch("createTransaction", {
          workflow_type_name: this.workflowType,
          workflow_id: this.workflowID,
          business_id: this.businessID,
          created_by: this.passengerID,
          handled_by: this.driverID,
          data: obj,
        })
        .then(() => {
          this.$swal({
            title: this.$t("transport.waiting-for-confirmation"),
            showConfirmButton: false,
            timer: 2000,
          });
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.create-transaction {
  width: 100vw;
  overflow: hidden;
}
.notification {
  padding: 1rem;
  padding-top: 0;
}
.label {
  margin-bottom: 0;
  margin-left: 6px;
  opacity: 0.7;
}
.column {
  padding-bottom: 0;
}
/* .column {
  padding: 12px 4px;
} */
.tag {
  padding: 0 6px;
}
.single-line {
  white-space: nowrap;
  overflow: scroll;
  display: inline-block;
}
</style>
